/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdistandardcodeList.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-standard-code-list";

export class AutogenModelEdistandardcodeList<RowType extends ModelRow> extends Endpoint<RowType, RowEdistandardcodeListFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdistandardcodeList extends ModelRow<RowEdistandardcodeListFields> {
	constructor(values?: Partial<RowEdistandardcodeListFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdistandardcodeListFields {
	company_id: string;
	description: string;
	element_id: string;
	standard_code: string;
	version: string;
}

